import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";
import EmptyLine from "../../EmptyLine";
import {useUser} from "../../../Context/UserContext";
import ResultView from "../../V2/ResultView";

export function C19({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}
const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.C19_SEC01.error_id: {
            return (
                <>
                    <ResultText>
                        There is cross section station reference adjustment at the following {row?.data?.length} cross sections:
                        <EmptyLine />
                        <ComparisonCSName csNameList={row?.data?.map(x => x.cross_section)} />
                    </ResultText>

                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}